<template>
    <div>

      <!-- 底部开始 -->
      <div class="footer">
        <div class="container text-center wow animated fadeInUp" >
<!--          <div class="row ft">-->
<!--            <ul class="list-unstyled list-inline">-->
<!--              <li class="bottom_button"><a href="/">官网首页</a></li>-->
<!--              <li class="bottom_button"  @click="scroll"><router-link :to="link">下载中心</router-link></li>-->
<!--              <li class="bottom_button"  @click="scroll"><router-link to="/contact">联系我们</router-link></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <div class="row" >-->
<!--          </div>-->

          <div class="row text-center" style="margin-top: 60px">
              <div class="col-md-4" style="padding: 0;margin-left: 200px">
                <p style="text-align: left;margin-top: 6px;font-size: 14px;margin-bottom: 0"><img src="../assets/news/bottom_icon_mail.png" alt=""><span style="margin-left: 13px">support@kingmuch.cn</span></p>
                <p style="text-align: left;margin-top: 6px;font-size: 14px;margin-bottom: 0"><img src="../assets/news/bottom_icon_tel.png" alt=""><span style="margin-left: 13px">0755-86567119/0755-26038583</span></p>
                <p style="text-align: left;margin-top: 6px;font-size: 14px;margin-bottom: 0"><img src="../assets/news/bottom_icon_address.png" alt=""><span style="margin-left: 13px">深圳市南山区中祥路8号君翔达大厦A栋2楼Y区</span></p>
              </div>
              <div class="col-md-3 col-md-offset-2" style="text-align: left">
                <div style="width:93px;display: inline-block;overflow: hidden">
                  <img src="../assets/news/bottom_img_official.png" alt="" class="img-responsive">
                  <p style="font-size: 16px;margin-top: 8px;text-align: center">企业官网</p>
                </div>
                <div  style="width: 93px;display: inline-block;overflow: hidden;margin-left: 60px;">
                  <img src="../assets/news/bottom_img_magician.png" alt="" class="img-responsive">
                  <p style="font-size: 16px;margin-top: 8px;text-align: center">关注公众号</p>
                </div>

              </div>
        </div>

          <div class="ba">
          <p>Copyright© 2019-2023 KINGMUCH. All Rights Reserved.</p>
          <p><a href="https://api.majixing.com/isslpc.jpg" style="color: white" target="_blank">信息系统安全等级保护备案证明 |</a> <a href="http://beian.miit.gov.cn/" style="color: white" target="_blank">粤ICP备13006708号</a> </p>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004003" target="_blank"><p><img src="../assets/news/bottom_img_record.png" alt="">粤公网安备 44030502004003号</p></a>

        </div>


        </div>
      </div>
  <!-- 底部结束 -->

    </div>
</template>

<script>
    import {WOW} from "wowjs";

    export default {
      name: "foot",
      data(){
        return{
          link:''
        }
      },
      // 动画特效
      mounted() {
        // 在项目加载完成之后初始化wow动画特效
        var wow = new WOW({
          boxClass: 'wow',//需要执行动画的元素的 class
          animateClass: 'animated',//animation.css 动画的 class
          offset: 0,//距离可视区域多少开始执行动画
          mobile: true,//是否在移动设备上执行动画
          live: true//异步加载的内容是否有效
        })
        wow.init();
      },
      created() {
        this.isMobile();
        // this.link=location.href.split('#')[1]
        // this.path()
      },
      methods: {
        isMobile() {
          let ua = navigator.userAgent,
            // if(ua.match(/MicroMessenger/i)=="micromessenger")
            isWx = /(?:MicroMessenger)/.test(ua),
            isWindowsPhone = /(?:Windows Phone)/.test(ua),
            isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
            isAndroid = /(?:Android)/.test(ua),
            isFireFox = /(?:Firefox)/.test(ua),
            isChrome = /(?:Chrome|CriOS)/.test(ua),
            isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
            isPhone = /(?:iPhone)/.test(ua) && !isTablet,
            isPc = !isPhone && !isAndroid && !isSymbian;
          if (isAndroid || isPhone) {
            location.href = location.href.toString().replace('www','wap')
          } else if (isTablet) {
          } else if (isPc) {
          }
        },
        // scroll(){
        //   window.scrollTo(0,0)
        // },
        // path(){
        //   let path=location.href.split('#')[1]
        //   if(path==='/Creation'){
        //     this.link='/chuangzuo_download'
        //   } else if(path==='/Teaching'){
        //     this.link='/teacher_download'
        //   } else if(path==='/chuangzuo_download'){
        //     this.link='/chuangzuo_download'
        //   }else {
        //     this.link='/teacher_download'
        //   }
        // }
      }
    }
</script>

<style scoped>

  /*底部*/
  .footer{
    /*background:url(../assets/images/footerbj.png)no-repeat center;*/
    /*background-size: cover;*/
    height: 300px;
    background-color: #2B9CA5;
  }

  .footer ul li>a{
    /*padding-left:10px;padding-right: 15px;*/
    font-size: 20px;
    color: #ffffff;
    padding: 0;
  }
  /*.footer ul li>a:nth-last-child(1){*/
  /*  padding-left:19px;*/
  /*}*/
  .footer p{
    font-size: 14px;
    color: #ffffff;
  }

  .ft{
    margin-top:200px;
  }

  .ba{
    margin-top:20px;

  }

  p{
    margin-bottom: 0;
  }



  /*小于768*/
  @media (max-width:768px) {
    .ft{
      margin-top:120px;margin-bottom:10px;
    }

    .ba{
      margin-top:40px;margin-bottom:20px;
    }
    .form-group {
      margin-top: 10px;
    }
    .footer ul li>a {
      font-size: 14px;

    }
  }

  .bottom_button{
    border: thin solid rgba(255, 255, 255, 1);
    padding: 6px 29px;
    border-radius: 20px;
    margin-right: 27px;
  }

</style>



// WEBPACK FOOTER //
// src/components/foot.vue